var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"app-shell"},[_c('el-aside',{attrs:{"width":"220px"}},[_c('AppSidebar')],1),_c('el-container',[_c('el-header',{attrs:{"height":"72px"}},[_c('AppHeader')],1),_c('el-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }